import { render, staticRenderFns } from "./ShareLandingCom.vue?vue&type=template&id=3553e5ae&scoped=true"
import script from "./ShareLandingCom.vue?vue&type=script&lang=js"
export * from "./ShareLandingCom.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingCom.vue?vue&type=style&index=0&id=3553e5ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553e5ae",
  null
  
)

export default component.exports